var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm.classes,staticStyle:{"padding":"10px","display":"flex","margin-bottom":"12px"}},[_c('div',{staticStyle:{"width":"26px","display":"flex","align-items":"center"}},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticStyle:{"width":"calc(100% - 34px)","padding-top":"2px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }